// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import TimeReport from 'services/data/time-report';

// Components
import { DeleteButton } from 'components/widgets/buttons';
import Tooltip from 'components/widgets/overlays/tooltip';


// Component
export default class ArchiveTimeReport extends React.Component {
  static propTypes = {
    report: PropTypes.object.isRequired,
    afterSubmit: PropTypes.func,
    eagerUpdate: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.unarchiveTimeReport = this.unarchiveTimeReport.bind(this);
  }

  unarchiveTimeReport() {
    const { report, afterSubmit, eagerUpdate } = this.props;
    const updates = { id: report.id, status: 'Archived' };

    if (eagerUpdate) eagerUpdate(updates);

    TimeReport.update(updates)
      .then((response) => {
        if (afterSubmit) afterSubmit(response);
      })
      .catch(alerts.catchError);
  }

  render() {
    const { report } = this.props;

    return (
      <div>
        { !report.invoice &&
          <DeleteButton onClick={this.unarchiveTimeReport} />
        }
        { report.invoice &&
          <Tooltip title="This time report has been invoiced and can't be archived">
            <DeleteButton disabled />
          </Tooltip>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/time-report/archive-time-report.js